/**
 * Shared constants for the Cleaning Service module.
 * Used by ServiceClientsPage, ServiceClientDetail, and service modals.
 */

export const CLIENT_TYPE_LABELS = {
  residential: 'سكني',
  'str-owner': 'مالك وحدات',
  commercial: 'تجاري',
};

export const LOCATION_TYPE_LABELS = {
  residential: 'سكني',
  'str-unit': 'وحدة إيجار قصير',
  office: 'مكتب',
  commercial: 'تجاري',
};

export const REQUEST_STATUS_LABELS = {
  pending: 'بانتظار التعيين',
  scheduled: 'تم قبول الطلب',
  'in-progress': 'قيد التنفيذ',
  completed: 'مكتمل',
  cancelled: 'ملغي',
};

export const PAYMENT_STATUS_LABELS = {
  pending: 'غير مدفوع',
  paid: 'مدفوع',
  overdue: 'متأخر',
};

export const SUBSCRIPTION_STATUS_LABELS = {
  active: 'نشط',
  paused: 'متوقف',
  cancelled: 'ملغي',
};

export const PAYMENT_METHOD_LABELS = {
  bank_transfer: 'تحويل بنكي',
  cash: 'نقدي',
  subscription: 'اشتراك',
};
